import styled from 'styled-components'

export const ConfirmImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`
